import { isNullable } from "utils/helpers/is-nullable";
import { isFiniteNumber } from "./is-finite-number";

export const getRandomInteger = (fromInclusive: number, toExclusive?: number): number => {
  if (isNullable(toExclusive)) {
    toExclusive = fromInclusive;
    fromInclusive = 0;
  }
  if (!isFiniteNumber(fromInclusive) || !isFiniteNumber(toExclusive)) return NaN;
  return Math.floor(Math.random() * (toExclusive - fromInclusive)) + fromInclusive;
};
